export const homeObjOne = {
  id: "about",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topline: "Crop Losses due to diseases",
  headline: "Indian Farmers lose upto ₹ 90,000 crores annually",
  description:
    "10 to 30 percent of crop production are lost due to diseases, pests and weeds thus, decreasing the productivity and affecting the economy of the country.",
  buttonLabel: "Get started",
  imgStart: false,
  img: require("../../../assets/images/HomePage/svg-1.svg").default,
  alt: "icons",
  dark: true,
  primary: true,
  darkText: true,
};

export const homeObjTwo = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topline: "Aiding Indian Farmers",
  headline: "One-Stop Solution for Crop Related Issues",
  description:
    "Detection and Reliable Solutions, Teleconsulting with Experts and a Community Forum for Farmers.",
  buttonLabel: "Get started",
  imgStart: false,
  img: require("../../../assets/images/HomePage/svg-2.svg").default,
  alt: "icons",
  dark: true,
  primary: true,
  darkText: false,
};

export const homeObjThree = {
  id: "about",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topline: "Problems faced by Farmers",
  headline: "Knowing the exact crop disease is important before treating it.",
  description:
    "Not all farmers possess enough technological literacy to carry out independent research about crop diseases and their solutions; they’re often taken advantage of by traders who make them spend money on large quantities of unnecessary chemicals, pesticides and insecticides, which are detrimental to the soil and environment.",
  buttonLabel: "Get started",
  imgStart: false,
  img: require("../../../assets/images/HomePage/svg-3.svg").default,
  alt: "icons",
  dark: true,
  primary: true,
  darkText: true,
};
